// The source sections of the designer's metric filter.
export enum SourceCategory {
	ALL = 'all',
	CONNECTED_SOURCES = 'connected',
	INTEGRATIONS = 'integrations',
}

// The designer's metric type filter.
export enum MetricFilterType {
	ALL = 0,
	FAVORITE = 1,
	POPULAR = 2,
	BASIC = 3,
	QUERY = 4,
	SCRIPT = 5,
	VERIFIED = 6,
}
